import { render, staticRenderFns } from "./RowDetail.vue?vue&type=template&id=84f6fc64&"
import script from "./RowDetail.vue?vue&type=script&lang=js&"
export * from "./RowDetail.vue?vue&type=script&lang=js&"
import style0 from "./RowDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports